<template>
  <router-view />
</template>

<script>
export default {
  name: "internalRTech"
};
</script>

<style></style>
